const CONDITION_TRANSITION_MS = 300;
const CONDITION_TRANSITION_BUFFER_MS = 50;

// Resolve on transitionend OR a timeout fallback, so a missed event never wedges a row.
function afterHeightTransition(element) {
  return new Promise((resolve) => {
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      element.removeEventListener("transitionend", onTransitionEnd);
      clearTimeout(timer);
      resolve();
    };

    const onTransitionEnd = (event) => {
      if (event.target === element && event.propertyName === "height") finish();
    };

    element.addEventListener("transitionend", onTransitionEnd);
    const timer = setTimeout(
      finish,
      CONDITION_TRANSITION_MS + CONDITION_TRANSITION_BUFFER_MS
    );
  });
}

class ConditionAccordion extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      const button = event.target.closest(".js-condition-btn");
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      this.toggleRow(button);
    });
  }

  async toggleRow(button) {
    const body = button.nextElementSibling;
    if (!body) return;

    const willOpen = button.getAttribute("aria-expanded") !== "true";
    const row = button.closest("[data-condition-row]");

    button.setAttribute("aria-expanded", String(willOpen));
    if (row) row.classList.toggle("is-open", willOpen);

    const seq = (body.dataset.seq ? Number(body.dataset.seq) : 0) + 1;
    body.dataset.seq = String(seq);

    body.style.height = `${body.getBoundingClientRect().height}px`;
    body.getBoundingClientRect(); // force reflow before changing direction
    body.style.height = willOpen ? `${body.scrollHeight}px` : "0px";

    await afterHeightTransition(body);

    if (Number(body.dataset.seq) !== seq) return; // superseded by a newer toggle

    body.style.height = willOpen ? "auto" : "0px";

    const parentBody = button.closest(".accordion__body");
    if (parentBody && !parentBody.classList.contains("is-transitioning")) {
      parentBody.style.height = "auto";
    }
  }
}

customElements.define("condition-accordion", ConditionAccordion);
